import getAxios from './axiosService'

const _tracekey = 'kkComicTraceId'
const _userkey = 'kkComicUserInfo'
const _branchkey = 'kkComicBranchId'
const _fromkey = 'kkComicFrom'

function guid() {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function getTraceId () {
  return window.localStorage.getItem(_tracekey)
}

function setTraceId (id) {
  window.localStorage.setItem(_tracekey, id)
}

function getUserInfo () {
  var userInfo = window.localStorage.getItem(_userkey)
  if (userInfo && userInfo !== 'undifined') {
    return JSON.parse(userInfo)
  }
  return null
}

function setUserInfo (userInfo) {
  window.localStorage.setItem(_userkey, JSON.stringify(userInfo))
}

function getUserFrom () {
  return window.localStorage.getItem(_fromkey)
}

const userService = {
  submitFromInfo () {
    return new Promise((resolve, reject) => {
      let axios = getAxios()
      let referUrl = document.referrer
      axios.post('/api/user/user_from_mark', {}, {
        params: {
          referUrl: referUrl
        }
      })
        .then(res => {
          if (res.status === 200) {
          }
        })
    })
  },
  getLocalUserInfo () {
    return getUserInfo()
  },
  getLocalUserFrom () {
    return window.localStorage.getItem(_fromkey)
  },
  setUserFrom (fromDomain) {
    window.localStorage.setItem(_fromkey, fromDomain)
  },
  getTraceId () {
    let storageTraceId = getTraceId()
    if (!storageTraceId || storageTraceId === '') {
      storageTraceId = guid()
      setTraceId(storageTraceId)
    }
    return storageTraceId
  },
  setTraceId (traceId) {
    setTraceId(traceId)
  },
  setBranchId (branchId) {
    window.localStorage.setItem(_branchkey, branchId)
  },
  getBranchId () {
    let branchId = window.localStorage.getItem(_branchkey)
    if (branchId) {
      return branchId
    } else {
      let userInfo = getUserInfo()
      if (userInfo) {
        return userInfo.branchId
      } else {
        return -2
      }
    }
  },
  register () {
    let user = getUserInfo()
    if (!user) {
      return new Promise((resolve, reject) => {
        let axios = getAxios()
        let userFrom = getUserFrom()
        axios.post(`/api/user/register?fromDomain=${userFrom}`)
          .then(res => {
            if (res.status === 200) {
              if (res.data.result) {
                setUserInfo(res.data.data)
                setTraceId(res.data.data.visitorId)
              }
              resolve(res.data)
            } else {
              reject()
            }
          })
      })
    }
  },
  getUserInfo () {
    return new Promise((resolve, reject) => {
      // const userInfo = getUserInfo()
      const axios = getAxios()
      axios.get('/api/user/info')
        .then(res => {
          if (res.status === 200) {
            setUserInfo(res.data.data)
            setTraceId(res.data.data.visitorId)
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  updateUserInfo () {
    const axios = getAxios()
    axios.get('/api/user/info')
      .then(res => {
        if (res.status === 200) {
          setUserInfo(res.data.data)
          setTraceId(res.data.data.visitorId)
          return res.data.data
        }
      })
  },
  updateLocalUserInfo (userInfo) {
    setUserInfo(userInfo)
  },
  bindMobile (mobile, password) {
    return new Promise((resolve, reject) => {
      // const userInfo = getUserInfo()
      const axios = getAxios()
      axios.post('/api/user/bind_mobile', {}, {
        params: {
          mobile: mobile,
          password: password
        }
      })
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  changePwd (newPwd) {
    return new Promise((resolve, reject) => {
      // const userInfo = getUserInfo()
      const axios = getAxios()
      axios.post('/api/user/modify_pwd', {}, {
        params: {
          password: newPwd
        }
      })
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  login (mobile, password) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.post('/api/user/login', {}, {
        params: {
          account: mobile,
          password: password
        }
      })
        .then(res => {
          if (res.status === 200) {
            setUserInfo(res.data.data)
            setTraceId(res.data.data.visitorId)
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  submitContactInfo (contactType, contactPosition) {
    return new Promise((resolve, reject) => {
      let axios = getAxios()
      let userInfo = this.getLocalUserInfo()
      axios.post('/api/user/submit_contact', {}, {
        params: {
          userId: userInfo ? userInfo.userId : null,
          visitorId: this.getTraceId(),
          contactType: contactType,
          contactPosition: contactPosition
        }
      }).then(res => {
      })
    })
  },
  openQQ (qq, contactPosition) {
    this.submitContactInfo('qq', contactPosition)
    window.location.href = 'mqqwpa://im/chat?chat_type=wpa&uin=' + qq + '&version=1&src_type=web&web_src=oicqzone.com'
  },
  openEmail (email, contactPosition) {
    this.submitContactInfo('email', contactPosition)
    window.location.href = 'mailto:' + email
  },
  buyRecords (currentPage = 1) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.post(`/api/user/buy_records/${currentPage}`)
        .then(res => {
          if (res.status === 200 && res.data.result) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  rechargeRecords (currentPage = 1) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.post(`/api/user/recharge_records/${currentPage}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  },
  findAccount (query) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.post(`/api/user/find_account?${query}`)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data)
          } else {
            reject(res.data)
          }
        })
    })
  }
}

export default userService
